import { TestaCPF } from "../validateCpf";

export function required(value?: string) {
  return value && value.trim() !== "" ? undefined : "Campo obrigatório";
}

export function maxLength(max: number, value?: string) {
  return value && value.length > max
    ? `Máximo de ${max} caracteres`
    : undefined;
}

export function minLength(min: number, value?: string) {
  return value && value.length < min
    ? `Mínimo de ${min} caracteres`
    : undefined;
}

export function containsCharacters(characters: string) {
  return (value?: string) => {
    return value && !value.match(characters)
      ? `Deve conter ${characters}`
      : undefined;
  };
}

export function isEmail(value?: string) {
  return value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    ? "Email inválido"
    : undefined;
}

export function itsMinimumCepLength(value?: string) {
  console.log("itsSmaller value:", value); // Adicione este log
  return value && value.replace(/\D/g, "").length < 8 ? "Digite pelo menos 8 dígitos" : undefined;
}

// validação para idade entre 18 e 120 anos
export function isAdult(value?: string) {
  if (!value || value.trim() === "") return undefined;

  const date = new Date(value || "");
  const age = new Date().getFullYear() - date.getFullYear();
  return age >= 18 && age <= 120 ? undefined : "Idade inválida";
}

export function isCpf(value?: string) {
  console.log("testando cpf", value);
  return value && value.trim().length > 0 && !TestaCPF(value)
    ? "CPF inválido"
    : undefined;
}

export function isCnpj(value?: string) {
  const cnpjRegex = /^(\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})$/;
  if (value && !cnpjRegex.test(value)) 
    return 'CNPJ inválido';
  return undefined;
}

export const validators = {
  required,
  maxLength,
  minLength,
  containsCharacters,
  isEmail,
  itsMinimumCepLength,
  isAdult,
  isCpf,
  isCnpj,
};
